import { render, staticRenderFns } from "./player-view-page.vue?vue&type=template&id=59e23ce9&"
import script from "./player-view-page.vue?vue&type=script&lang=js&"
export * from "./player-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports